interface UseContractUserTypeReturn {
    isPrimaryContact: boolean;
    isSecondaryContact: boolean;
    isStudioUser: boolean;
    isClientUser: boolean;
}

export const UseContractUserType = (
    contractUserEmail: string,
    contractContacts: SpApi.Client.IContact[]
): UseContractUserTypeReturn => {
    const formattedContractUserEmail = contractUserEmail.toLowerCase();
    const firstContractContactEmail = (contractContacts?.[0]?.email || '').toLowerCase();
    const secondContractContactEmail = (contractContacts?.[1]?.email || '').toLowerCase();

    return {
        isPrimaryContact: formattedContractUserEmail === firstContractContactEmail,
        isSecondaryContact: formattedContractUserEmail === secondContractContactEmail,
        isStudioUser:
            formattedContractUserEmail !== firstContractContactEmail &&
            formattedContractUserEmail !== secondContractContactEmail,
        isClientUser:
            formattedContractUserEmail === firstContractContactEmail ||
            formattedContractUserEmail === secondContractContactEmail
    };
};
